import { PaginationBar } from "@components/PaginationBar";
import { CoinDropdownItem } from "@components/dropdown/CoinDropdownItem";
import { CustomDropdown } from "@components/dropdown/CustomDropdown";
import { SimpleDropdownItem } from "@components/dropdown/SimpleDropdownItem";
import { NftCardV2 } from "@components/nft/NftCardV2";
import { useCoins } from "@contexts/CoinsContext";
import { useApi } from "@hooks/ApiHook";
import { CollectionResponse } from "baaanggg";
import React, { useState } from "react";

export interface Props {
    collection: CollectionResponse
}

export default function NftTab({ collection }: Props) {
    const [page, setPage] = useState(1)
    const [coinId, setCoinId] = useState<string>()
    const { coins } = useCoins()

    const { data: paginatedNft } = useApi(api => api.item.allNft({ collectionId: collection.id, page, coinId }), [collection, page, coinId])

    return <div>
        <div className="mb-8 flex flex-wrap items-center justify-between">
            <div className="flex flex-wrap items-center">
                <CustomDropdown
                    placeholder="Select payment type"
                    onSelected={coin => setCoinId(coin?.id)}
                    builder={(coin, isSelected) => <CoinDropdownItem
                        isSelected={isSelected}
                        coin={coin} />}
                    format={item => item.name}
                    items={coins} />
            </div>
        </div>
        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4">
            {
                paginatedNft?.data.map(nft => <NftCardV2 key={nft.identifier} nft={nft} />)
            }
        </div>

        <div className="mt-5"></div>

        {
            paginatedNft && <PaginationBar
                pagination={paginatedNft}
                currentPage={page}
                onPageChange={page => setPage(page)} />
        }
    </div>
}